"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IllustrationModalFamily = function IllustrationModalFamily(_ref) {
  var theme = _ref.theme;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "112",
    height: "70",
    fill: "none",
    viewBox: "0 0 112 70"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.primary[50],
    d: "M64.458.867H44.4c-12.837 0-23.243 10.378-23.243 23.18v22.64c0 12.803 10.406 23.18 23.243 23.18h20.058c12.837 0 23.243-10.378 23.243-23.18v-22.64C87.7 11.244 77.295.866 64.458.866z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    stroke: theme.primary[100],
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "2",
    d: "M1.34 60.443h109.32"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.primary[700],
    d: "M43.94 59.5h2.451V26.76l-3.075-4.468h-1.08c-3.075 0-3.892 2.242-3.916 3.363v14.581c0 2.287 1.97 3.099 2.955 3.22.44 4.755 1.345 14.422 1.44 15.037.145.768.53 1.009 1.226 1.009z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.primary[700],
    d: "M48.808 59.5h-2.451V26.76l3.075-4.468h1.081c3.075 0 3.892 2.242 3.916 3.363v14.581c0 2.287-1.97 3.099-2.955 3.22-.44 4.755-1.345 14.422-1.441 15.037-.144.768-.529 1.009-1.225 1.009z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "46.374",
    cy: "16.243",
    r: "4.997",
    fill: theme.primary[700]
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.primary[600],
    d: "M59.241 59.659h1.538c-.056-11.57-.169-34.88-.169-35.552-.384 0-2.594-.313-4.275-1.226-1.346-.73-2.146.192-2.379.745-1.537 3.755-4.674 11.391-4.924 11.89-.312.625-.504 1.514.769 2.283 1.018.615 1.962-.337 2.306-.889l3.94-9.296c.128 1.393.441 4.51.672 5.837.23 1.326-.016 2.666-.168 3.17-.97 2.995-2.984 9.191-3.291 10.018-.308.826.256.985.576.96h1.61c.96 0 1.249.545 1.273.817.504 3.131 1.552 9.58 1.706 10.33.153.75.608.92.816.913z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.primary[600],
    d: "M61.917 59.659H60.38c.056-11.57.168-34.88.168-35.552.384 0 2.594-.313 4.276-1.226 1.345-.73 2.145.192 2.378.745 1.537 3.755 4.674 11.391 4.924 11.89.313.625.505 1.514-.769 2.283-1.018.615-1.961-.337-2.306-.889l-3.94-9.296c-.127 1.393-.441 4.51-.672 5.837-.23 1.326.016 2.666.168 3.17.97 2.995 2.984 9.191 3.291 10.018.308.826-.256.985-.576.96h-1.61c-.96 0-1.249.545-1.273.817-.504 3.131-1.552 9.58-1.705 10.33-.154.75-.609.92-.817.913z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "60.579",
    cy: "16.396",
    r: "4.997",
    fill: theme.primary[600]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "70.866",
    cy: "31.606",
    r: "3.536",
    fill: theme.primary[500]
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.primary[500],
    d: "M70.923 36.656V59.5h-1.2c-.577 0-.754-.4-.77-.601-.224-1.922-.7-5.967-.816-6.774-.115-.807-.497-.993-.673-.985H66.36c-.71 0-.728-.593-.648-.889l2.21-11.338-.673 1.417-2.474 5.261c-.817 1.681-2.862.597-2.138-.985 1.129-2.466 3.42-7.48 3.555-7.807.168-.408.937-1.826 1.946-1.033.807.634 2.194.857 2.786.889z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: theme.primary[500],
    d: "M70.923 36.656V59.5h1.201c.577 0 .753-.4.77-.601.223-1.922.7-5.967.816-6.774.115-.807.496-.993.672-.985h1.105c.711 0 .73-.593.649-.889l-2.21-11.338.673 1.417 2.474 5.261c.817 1.681 2.862.597 2.138-.985-1.13-2.466-3.42-7.48-3.555-7.807-.169-.408-.937-1.826-1.946-1.033-.807.634-2.194.857-2.787.889zM31.09 49.547l.96 9.776c.065.313.318.937.818.937h1.897V34.941H31.09c-.36 0-2.09.145-2.09 2.09v10.45c0 1.614 1.393 2.05 2.09 2.066zM38.44 49.547l-.96 9.776c-.064.313-.317.937-.817.937h-1.898V34.941h3.675c.36 0 2.09.145 2.09 2.09v10.45c0 1.614-1.393 2.05-2.09 2.066z"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "34.765",
    cy: "30.502",
    r: "3.536",
    fill: theme.primary[500]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "71.357",
    cy: "13.899",
    r: "2.5",
    fill: theme.primary[500]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "36.265",
    cy: "12.399",
    r: "1.5",
    fill: theme.primary[500]
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "80",
    cy: "52.17",
    r: "1",
    fill: theme.primary[500]
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "2",
    height: "8",
    x: "28.935",
    y: "35.363",
    fill: theme.primary[500],
    rx: "1",
    transform: "rotate(45 28.935 35.363)"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "2",
    height: "8",
    x: "23.278",
    y: "36.777",
    fill: theme.primary[500],
    rx: "1",
    transform: "rotate(-45 23.278 36.777)"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "1.5",
    height: "6",
    x: "78.25",
    y: "22.612",
    fill: theme.primary[500],
    rx: "0.75"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    width: "1.5",
    height: "6",
    x: "76",
    y: "26.362",
    fill: theme.primary[500],
    rx: "0.75",
    transform: "rotate(-90 76 26.362)"
  }));
};

IllustrationModalFamily.propTypes = {
  theme: _propTypes.object
};
var _default = IllustrationModalFamily;
exports.default = _default;